import * as React from 'react'

import { SelectApi } from './types'

export type SelectContext = {
    navigableRegister: SelectApi['navigableRegister']
    register: SelectApi['register']
    deregister: SelectApi['deregister']
}

const selectContext = React.createContext<SelectContext | undefined>(undefined)

export function useSelectContext(): SelectContext {
    const context = React.useContext(selectContext)

    if (context === undefined) {
        throw Error('Option outside of Select')
    }

    return context
}

export const SelectContextProvider = selectContext.Provider
